module.exports = __webpack_public_path__ + "static/media/mashu_qr_code.5d857e77.jpg";